import { FC } from 'react';

import { AppFormattedMessage } from '../../../../../components/app-formatted-message/index';
import { VESTING_GRAPH_EVENT_COLUMN_WIDTH_PX } from '../model/vesting-graph.constants';
import {
  VestingGraphAccelerationMarker,
  VestingGraphExpiryMarker,
  VestingGraphOverlayLayer,
  VestingGraphPeriodBracket,
} from './vesting-graph-milestones';
import { useVestingGraphContext } from './vesting-graph-view-context';

type VestingGraphPlotMarkersProps = {
  layer: VestingGraphOverlayLayer;
};

/** Accel / expiry / hovered period — painted twice: wash under the series, captions above it. */
export const VestingGraphPlotMarkers: FC<VestingGraphPlotMarkersProps> = ({ layer }) => {
  const {
    view: {
      accelerationIndex,
      accelerationStack,
      barBaselineLiftPx,
      expiryIndex,
      expiryStack,
      hoveredPeriod,
      positionAt,
    },
  } = useVestingGraphContext();

  return (
    <>
      <VestingGraphPeriodBracket
        label={
          hoveredPeriod ? (
            <AppFormattedMessage
              id="VESTING_PERIOD_NUMBER"
              values={{ index: hoveredPeriod.index }}
            />
          ) : null
        }
        layer={layer}
        leftPercent={hoveredPeriod?.leftPercent ?? 0}
        open={hoveredPeriod !== null}
        widthPercent={hoveredPeriod?.widthPercent ?? 0}
      />
      {accelerationIndex !== null && (
        <VestingGraphAccelerationMarker
          bottomInsetPx={barBaselineLiftPx}
          label={<AppFormattedMessage id="ACCELERATION" />}
          layer={layer}
          leftPercent={positionAt(accelerationIndex)}
          stack={layer === 'badge' ? accelerationStack : undefined}
          widthPx={VESTING_GRAPH_EVENT_COLUMN_WIDTH_PX}
        />
      )}
      {expiryIndex !== null && (
        <VestingGraphExpiryMarker
          bottomInsetPx={barBaselineLiftPx}
          label={<AppFormattedMessage id="EXPIRY" />}
          layer={layer}
          leftPercent={positionAt(expiryIndex)}
          stack={layer === 'badge' ? expiryStack : undefined}
          widthPx={VESTING_GRAPH_EVENT_COLUMN_WIDTH_PX}
        />
      )}
    </>
  );
};
